/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smart_Wise_Cod_SwayInputs */

const fr_smart_wise_cod_sway = /** @type {(inputs: Smart_Wise_Cod_SwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme retiré avec succès`)
};

/**

* @param {Smart_Wise_Cod_SwayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const smart_wise_cod_sway = /** @type {((inputs?: Smart_Wise_Cod_SwayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smart_Wise_Cod_SwayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_smart_wise_cod_sway(inputs)
});